import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import { graphql } from '@/gql/graphql';

const PersonRsvpMutationFragment = graphql(/* GraphQL */ `
  fragment PersonRsvpMutation on person {
    id
    rsvp(args: { event_id: $eventId })
    rsvps(where: { event_id: { _eq: $eventId } }, limit: 1) {
      __typename
      event_id
      person_id
      status
    }
  }
`);

type RsvpStatus = ReturnType<typeof graphql.scalar<'rsvp_status_enum'>>;

export type RsvpMutationCache = Pick<Cache, 'writeFragment'>;

const EventRsvpMutationFragment = graphql(`
  fragment EventRsvpMutation on event {
    id
    rsvp(args: { person_id: $personId })
  }
`);

export default function insert_rsvp_one(
  _parent: unknown,
  args: {
    object?: {
      event_id?: string;
      person_id?: string;
      status?: RsvpStatus | null;
    };
  },
  cache: RsvpMutationCache,
  _info?: ResolveInfo,
) {
  const eventId = args.object?.event_id;
  const personId = args.object?.person_id;
  const status = args.object?.status;

  if (!eventId || !personId || status === undefined) {
    return;
  }

  cache.writeFragment(
    EventRsvpMutationFragment,
    { id: eventId, rsvp: status },
    { personId: personId },
  );

  cache.writeFragment(
    PersonRsvpMutationFragment,
    {
      id: personId,
      rsvp: status,
      rsvps: [
        {
          __typename: 'rsvp',
          event_id: eventId,
          person_id: personId,
          status,
        },
      ],
    },
    { eventId },
  );
}
